import { h, Component } from 'preact';
import pure from 'utils/pure';
import s from 'components/shared/cookies/cookies.sss';
import { joinClasses } from 'utils/utils';

export default @pure class Cookies extends Component {

	constructor(props, ...args) {
		super(props, ...args);

		let appData = props.appData || {};

		const copy = appData.copy || {};
		let copyElements = [
			'$COOKIE_TEXT_START',
			'$COOKIE_TEXT_HERE',
			'$COOKIE_TEXT_END',
			'$COOKIE_TEXT_REMOVE'
		];
		const options = appData.options || {};
		const usesExternalCookieBanner = options.enableEnsighten || options.enableTealiumCookieConsent || options.oneTrustCookieConsent;
		
		this.show = copyElements.every(e => typeof copy[e] === 'string') && !usesExternalCookieBanner;

		let meta = appData.meta || {};
		let title = meta.title && meta.title.slug;
		let region = meta.region && meta.region.slug;
		this.cookieName = 'cookie-'+ title + '-' + region;
		this.cookieValue = 'on';
		this.cookieDuration = 14;
	}

	componentWillMount() {
		// check that it's not being iframed
		if (!this.show || typeof window === 'undefined' || window.top !== window.self || window.cookieSetup) {
			return;
		}
		window.cookieSetup = true;

		if (this.getCookie(this.cookieName) !== this.cookieValue) {
			this.setState({ display: true });
			this.setCookie(this.cookieName, this.cookieValue, this.cookieDuration);
		}
	}

	render({ appData }) {
		if (!this.show) {
			return;
		}
		const copy = appData.copy || {};
		return (
			<div class={joinClasses(s.cookieLaw, this.state.display && s.display, this.state.removed && s.removed)} key="cookie">
				<div class={s.cookieText}>
					{copy.$COOKIE_TEXT_START}
					<a href={appData.urls.cookieTextLink} target="_blank" tabindex="1">{copy.$COOKIE_TEXT_HERE}</a>
					{copy.$COOKIE_TEXT_END}
				</div>
				<button
					class={joinClasses(s.closeCookieBanner, copy.$COOKIE_TEXT_REMOVE.toLowerCase() === 'x' && s.isX)}
					onClick={this.removeMe}
					tabindex="2"
				>
					<span>{copy.$COOKIE_TEXT_REMOVE}</span>
				</button>
			</div>
		);
	}

	setCookie(name, value, days) {
		let expires = '';
		if (days) {
			let date = new Date();
			date.setTime(date.getTime() + (days * 24 * 3600 * 1000));
			expires = '; expires=' + date.toGMTString();
		}
		document.cookie = name + '=' + value + expires + '; path=/';
	}

	getCookie(name) {
		let nameEq = name + '=';
		let cookies = document.cookie.split(';');
		let matching = cookies.find(cookie => cookie.trim().startsWith(nameEq));
		if (matching) {
			return matching.slice(nameEq.length);
		}
		return null;
	}

	// eraseCookie(name) {
	// 	this.setCookie(name, '', -1);
	// }

	removeMe = () => {
		this.setState({ removed: true });
	}
}
